import React from "react";
import ArrowSVG from "@/assets/icons-js/arrow";
import { useStateContext } from "@/components/state";
import NonSsrWrapper from "@/components/wrappers/non-ssr-wrapper";
import useEventListener from "@/hooks/EventListener";

const Navigation = ({ next, formRef }) => {
    const context = useStateContext();
    const { state, dispatch } = context;

    const previous = () => {
        let value = state.scenes.current;
        value = value > 1 ? value - 1 : 1;

        dispatch({ scenes: { current: value }})
        window.scrollTo({ top: 0 });
    }

    const keydownEvent = (e) => {
        if (["INPUT", "TEXTAREA"].includes(e.target.tagName)) return;

        const clickedLeft = e.keyCode === 37;
        const clickedRight = e.keyCode === 39;

        if (clickedLeft) previous();
        if (clickedRight && state?.scenes?.current !== state?.scenes?.total) {
            formRef?.current?.requestSubmit?.();
        }
    }
    useEventListener("keydown", keydownEvent);

    return (
        <NonSsrWrapper>
            <div className="group group--compact sm-justify--space-between mt-10 mx-a gg-2 sm-gg-0 form__navigations" style={{ maxWidth: "960px" }}>
                <button
                    className={ ["form__navigation", state?.scenes?.current === 1 ? "hidden--partial" : "" ].join(" ") }
                    type="button"
                    onClick={previous}
                    disabled={state?.conditions?.locked || state?.scenes?.current === 1}
                >
                    <ArrowSVG/> <p>Tilbake</p>
                </button>

                <button
                    className={ ["form__navigation", state?.scenes?.current >= state?.scenes?.total ? "md-hidden--hard lg-hidden--hard hidden--partial" : ""].join(" ") }
                    type="submit"
                    disabled={state?.conditions?.locked || state?.scenes?.current >= state?.scenes?.total}
                >
                    <p>Neste</p> <ArrowSVG/>
                </button>
            </div>
        </NonSsrWrapper>
    );
};

export default Navigation;
